import { Component, Prop } from 'vue-property-decorator'
import Operation from '../../../../../dPplanningOp/vue/Classes/ClvrOperation'
import { Nullable } from '@internal-libraries/kheops-ui-lib'
import ClvrScreenControlCellAbstract from './ClvrScreenControlCellAbstract'

@Component({
    components: {},
})
export default class ClvrScreenControlCellComponent extends ClvrScreenControlCellAbstract {
    @Prop({ type: Object, default: null })
    public interventionData!: Nullable<Operation>

    @Prop({ type: String, default: '' })
    public cellType!: string
}
